











import { Component, Prop, Emit, Vue, Watch } from "vue-property-decorator";
import CheckboxComponent from "@/components/common/parts/CheckboxComponent.vue";

@Component({
  components: {
    CheckboxComponent
  }
})
export default class IconCheckboxComponent extends Vue {
  @Prop()
  id!: string;

  @Prop()
  label!: string;

  @Prop()
  imageOn!: string;

  @Prop()
  imageOff!: string;

  @Prop({
    default: false
  })
  value!: boolean;

  @Prop({
    default: 1
  })
  dispFlg!: number;

  internalValue: boolean = this.value;

  @Emit()
  change(value: boolean) {
    return value;
  }

  @Watch("value")
  changeValue() {
    this.internalValue = this.value;
  }

  handleChange(newValue) {
    this.internalValue = newValue;
    this.change(newValue);
  }

  get image() {
    return this.internalValue ? this.imageOn : this.imageOff;
  }
}
